<template>
  <!-- Modal -->
  <div
    class="modal fade text-xs-left"
    id="modalQR"
    tabindex="-1"
    v-if="$store.state.active_qr"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="closeBtnQR"
            ref="closeQR"
            class="close"
            data-dismiss="modal"
            @click="$store.state.active_qr = false"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h3 style="margin-bottom: 0">
            <i class="icon-qrcode"></i> QR code
            <i v-if="destroyed_cam"> - {{ $t("qr.notallowed") }}</i>
          </h3>
        </div>

        <div class="card-body">
          <div class="row">
            <p v-if="noFrontCamera">{{ $t("qr.nofrontcam") }}</p>
            <p v-if="noRearCamera">{{ $t("qr.norearcam") }}</p>

            <div class="row">
              <div class="col-md-12" style="max-height: 50vh">
                <qrcode-stream
                  :track="true"
                  :camera="camera"
                  @decode="onDecode"
                  @init="onInit"
                  v-if="!destroyed_cam"
                >
                  <div class="input-group">
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-warning"
                        @click="switchCamera"
                      >
                        <i class="nc-icon nc-refresh-69"></i>
                      </button>

                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="reloadcam"
                      >
                        <i class="nc-icon nc-button-power"></i>
                      </button>
                    </div>
                  </div>

                  <div class="card-block text-xs-center" v-show="cam_loading">
                    <div class="mt-2">
                      <i class="icon-gear-a spinner font-large-2"></i>
                    </div>
                  </div>
                </qrcode-stream>
              </div>
            </div>
            <!--<qrcode-capture @decode="onDecodefileload" />-->
          </div>
        </div>
        <div class="card-footer">
          <!--<div style="display: flex; justify-content: center">
                    <button type="button" class="btn btn-warning">
                        <h3 style="margin: 0"><i class="nc-icon nc-refresh-69"></i></h3>
                    </button>
                    <button type="button" class="btn btn-warning">
                        <h3 style="margin: 0"><i class="nc-icon nc-camera-compact"></i></h3>
                    </button>
                </div>-->

          <div class="col-md-12" v-if="destroyed_cam || manual">
            <div class="input-group">
              <div class="input-group-prepend" v-if="manual_btn">
                <span
                  class="input-group-text btn-warning hand"
                  style="
                    background-color: #fbc658;
                    color: #ffffff;
                    font-weight: 600;
                    font-size: 0.8571em;
                    padding-left: 1rem;
                    padding-right: 1rem;
                  "
                  @click="
                    destroyed_cam = false;
                    manual_btn = false;
                  "
                >
                  {{ $t("qr.activate") }} QR
                </span>
              </div>
              <div class="input-group-prepend" v-if="!manual_btn">
                <span
                  class="input-group-text btn-warning hand"
                  style="
                    background-color: #fbc658;
                    color: #ffffff;
                    font-weight: 600;
                    font-size: 0.8571em;
                    padding-left: 1rem;
                    padding-right: 1rem;
                  "
                  @click="
                    destroyed_cam = true;
                    manual_btn = true;
                  "
                >
                  {{ $t("qr.deactivate") }} QR
                </span>
              </div>

              <input
                class="form-control"
                type="text"
                id="seriale"
                v-model="resultQR"
                @keyup.enter="
                  qr_func(resultQR);
                  resultQR = null;
                  $refs.closeQR.click();
                "
              />

              <div class="input-group-append">
                <span
                  class="input-group-text btn-warning hand"
                  style="
                    background-color: #fbc658;
                    color: #ffffff;
                    font-weight: 600;
                    font-size: 0.8571em;
                    padding-left: 0.5rem;
                  "
                  @click="
                    qr_func(resultQR);
                    resultQR = null;
                    $refs.closeQR.click();
                  "
                >
                  <i class="nc-icon nc-bag-16"></i> {{ $t("qr.save") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="qr_loading">
      <div
        class="loader-overlay"
        id="point-loader"
        style="position: fixed !important"
      >
        <div
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <atom-spinner
            :animation-duration="1000"
            :size="160"
            :color="'#ff1d5e'"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";

export default {
  name: "QrCode",
  data() {
    return {
      resultCam: null,
      qr_loading: false,
      camera: "auto",
      manual_btn: true,
      resultQR: null,
      cam_loading: false,
      destroyed_cam: false,
      //features of cameras
      noRearCamera: false,
      noFrontCamera: false,
      errors: [],
    };
  },
  components: { QrcodeStream, QrcodeDropZone, QrcodeCapture, AtomSpinner },
  props: {
    qr_func: { type: Function, required: true },
    manual: { type: Boolean, required: false, default: false },
  },
  methods: {
    async onInit(promise) {
      this.cam_loading = true;
      this.manual_btn = false;

      try {
        //await promise
        const { capabilities } = await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          // user denied camera access permisson
          this.destroyed_cam = true;
        } else if (error.name === "NotFoundError") {
          // no suitable camera device installed
          this.destroyed_cam = true;
        } else if (error.name === "NotSupportedError") {
          // page is not served over HTTPS (or localhost)
          this.destroyed_cam = true;
        } else if (error.name === "NotReadableError") {
          // maybe camera is already in use
          this.destroyed_cam = true;
        } else if (error.name === "OverconstrainedError") {
          // did you requested the front camera although there is none?
        } else if (error.name === "StreamApiNotSupportedError") {
          // browser seems to be lacking features
          this.destroyed_cam = true;
        }

        const triedFrontCamera = this.camera === "front";
        const triedRearCamera = this.camera === "rear";
        const cameraMissingError = error.name === "OverconstrainedError";
        if (triedRearCamera && cameraMissingError) {
          this.noRearCamera = true;
        }
        if (triedFrontCamera && cameraMissingError) {
          this.noFrontCamera = true;
        }
        this.manual_btn = true;
        //console.error(error);
      } finally {
        this.cam_loading = false;
      }
    },
    turnCameraOn() {
      this.camera = "auto";
    },
    turnCameraOff() {
      this.camera = "off";
    },
    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    async reloadcam() {
      this.destroyed_cam = true;
      await this.$nextTick();
      this.destroyed_cam = false;
    },
    switchCamera() {
      switch (this.camera) {
        case "auto":
          this.camera = "rear";
          break;
        case "rear":
          this.camera = "front";
          break;
        case "front":
          this.camera = "auto";
          break;
      }
    },
    onDecode(result) {
      let res = result;
      if (this.isValid(res)) {
        let url = res.indexOf("http");
        if (url > -1) {
          res = res.substring(res.indexOf("/product/") + 9, res.length);
        }

        res = "ме-" + res.split("-")[1];

        if (res != null) {
          //this.$store.state.resultQR = res;
          this.qr_func(res);
          document.getElementById("closeBtnQR").click();
        }
      }
    },
  },
  watch: {},
  mounted() {
    if (this.manual) {
      this.destroyed_cam = true;
      this.manual_btn = true;
    }
    this.resultQR = null;
  },
};
</script>

<style scoped>
.hand {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/QrCode.vue